import { getConfig } from '../config';

import RestClient from './RestClient';

export interface CountUnseenNotificationsResponse {
  count: number;
}

class NotificationsClient extends RestClient {
  constructor() {
    super({
      baseUrl: `/gateway/api/notification-log/api/3/notifications`,
    });
  }

  countUnseenNotifications(): Promise<CountUnseenNotificationsResponse> {
    return this.getResource('/count/unseen');
  }
}

export default new NotificationsClient();
